<template>
  <section>
    <gs-header title="Quản lý danh mục bài viết">
      <router-link :to="{ name: 'create-category' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="categoryTable" :table-name="categoryTable" data-source="categories" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-select v-model="filters.type" filterable placeholder="Chọn loại danh mục" @change="filter"
                class="width-100">
                <el-option label="Chọn loại danh mục" :value="-1">
                </el-option>
                <el-option v-for="(type, key, index) in categoryHelpers.types" :key="index" :label="type" :value="key">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[categoryTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[categoryTable].current_page - 1) *
                    dataPaginations[categoryTable].per_page)}}</small>
              </template>
            </el-table-column>

            <el-table-column label="Tên">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Danh mục cha" width="250">
              <template slot-scope="scope">
                <p v-if="scope.row.parent">{{ scope.row.parent.data.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Kiểu danh mục" width="250">
              <template slot-scope="scope">
                <p>{{ scope.row.type_txt }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Trạng thái" width="250">
              <template slot-scope="scope">
                <label class="radio-inline" v-for="(status, key, index) in categoryHelpers.statuses" :key="key">
                  <input type="radio" :name="`status.${scope.row.id}`" :checked="scope.row.active === parseInt(key)"
                    @change="changeStatus(key, scope.row)"> {{ status }}
                </label>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Sửa" class="display-inline">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-category', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline">
                    <a @click.prevent="deleteCategory(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
      <el-dialog title="Xóa danh mục bài viết" :visible.sync="deleteModal">
        <p>Bạn chắc chắn muốn xóa danh mục bài viết <span class="text-blue text-bold">{{ category.name }}</span>?</p>
        <el-form label-width="0">
          <el-form-item>
            <el-button type="primary" @click="delCategory">Có </el-button>
            <el-button type="default" @click="deleteModal = false">Không </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { deleteCategory, editCategory } from 'src/api/categories'
import { debounce, head } from 'lodash'
import ls from 'local-storage'
import { mapGetters, mapActions } from 'vuex'
export default {

  name: 'Blog',

  data() {
    return {
      categoryTable: 'categories',
      filters: {
        sort: 'created_at:-1',
        include: 'parent',
        type: ''
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      deleteModal: false,
      active: ''
    }
  },
  computed: {
    ...mapGetters('category', ['category', 'categoryHelpers', 'categories'])
  },
  methods: {
    ...mapActions('category', ['setCategory', 'getCategoryHelpers', 'getAllCategories']),
    removeFilter() {
      this.reloadGsTable(this.categoryTable)
      this.filters = {
        sort: 'created_at:-1',
        include: 'parent',
        type: ''
      }
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.categoryTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.categoryTable)
      }
    }, 300),
    deleteCategory(category) {
      this.setCategory(category)
      this.$confirm(`Bạn chắc chắn muốn xóa danh mục bài viết: ${category.name} ?`, 'Xóa danh mục bài viết', {
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delCategory()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Hủy xóa danh mục bài viết'
        })
      })
    },
    delCategory() {
      deleteCategory(this.category.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa danh mục bài viết thành công'
          })
          this.deleteModal = false
          this.reloadGsTable(this.categoryTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa danh mục bài viết thất bại'
          })
        }
      })
    },
    changeStatus(status, category) {
      let currentCategory = Object.assign({}, category)
      currentCategory.active = status
      if (currentCategory.parent_id === 0) {
        currentCategory.parent_id = ''
      }
      editCategory(currentCategory.id, currentCategory).then(response => {
        switch (response.code) {
          case 200:
            this.$store.dispatch('showNotify', {
              title: 'Cập nhật thành công',
              body: 'Cập nhật trạng thái thành công'
            })
            this.reloadGsTable(this.categoryTable)
            this.toggleLoadding(false)
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin',
              body: message,
              type: 'warning'
            })
            this.toggleLoadding(false)
            break
          default:
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin',
              body: 'Cập nhật trạng thái thất bại',
              type: 'warning'
            })
            this.toggleLoadding(false)
        }
      })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.categoryTable]) {
      this.filters = ls.get('filters')[this.categoryTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    if (!Object.keys(this.categoryHelpers).length) {
      this.getCategoryHelpers()
    }
    this.sorted = this.getSorted(this.categoryTable)
    if (!this.categories.length) {
      this.getAllCategories({ limit: -1 })
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['categories']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped>
.radio-inline {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: 400;
  vertical-align: middle;
  cursor: pointer;
  margin-left: 15px;
}

.radio-inline input {
  position: absolute;
  margin-left: -20px;
  top: -2px;
}
</style>



// WEBPACK FOOTER //
// Category.vue?c0974598